import { init } from '@plausible-analytics/tracker'
init({
  domain: window.location.hostname
})
